/**
 * Ngữ cảnh thông báo nổi — tách khỏi `ThongBao.tsx` để mỗi tệp chỉ xuất một
 * loại thứ (component HOẶC hook). Gộp chung làm hỏng fast-refresh của Vite.
 */

import { createContext, useContext } from 'react'

export type SacThai = 'tot' | 'loi' | 'canh-bao' | 'tin'

export interface ThongBaoMoi {
  sac_thai?: SacThai
  tieu_de: string
  chi_tiet?: string
  /** Mili-giây trước khi tự tắt. `0` = ở lại tới khi người dùng đóng. */
  giay_song?: number
}

export interface BoThongBao {
  hien: (tb: ThongBaoMoi) => void
  bao_loi: (loi: unknown, tieu_de?: string) => void
  bao_xong: (tieu_de: string, chi_tiet?: string) => void
}

/* Mặc định ghi ra console thay vì ném lỗi: màn đăng nhập dựng trước khi vỏ
   ứng dụng gắn, và nó không được phép sập chỉ vì không hiện được thông báo. */
export const NguCanhThongBao = createContext<BoThongBao>({
  hien: (tb) => console.warn('[thông báo ngoài provider]', tb.tieu_de),
  bao_loi: (loi) => console.error('[lỗi ngoài provider]', loi),
  bao_xong: (t) => console.info('[thông báo ngoài provider]', t),
})

export function useThongBao(): BoThongBao {
  return useContext(NguCanhThongBao)
}
